import { MissionEventHandler } from '../mission'
import * as skylineApi from '../skylineApi'

export default class MissionGrsMarkers extends MissionEventHandler {
  grsMarkers = {}

  constructor(mission, parentLayer) {
    super(mission)

    this.addedLayer = true
    this.grsLayer = L.layerGroup()
    this.grsLayer.addTo(mymap)
    this.overlay = addOverlay("GRS", this.grsLayer, parentLayer)
  }

  get areAllRendered() {
    return Object.keys(this.grsMarkers).length >= this.mission.serverState.grsDeviceIds.length
  }

  handleMissionIndexJump(targetIndex) {
    this.clearGrsMarkers()

    let i = targetIndex
    while (!this.areAllRendered && i > 0 && i > targetIndex - 100) {
      const message = this.mission.history[i]
      if (message.type === 'SKYLINK_ADV_STATUS') {
        this.processStatus(message)
      }
      i--
    }
  }

  /** TODO: de-dupe from globalGrsMarkers.js *********************/
  addMarker(device) {
    const marker = L.marker([0, 0])
    this.grsMarkers[device.id] = marker
    this. updateMarker(device)
    marker.addTo(this.grsLayer)
    return marker
  }
  updateMarker(device) {
    const marker = this.grsMarkers[device.id]
    console.assert(marker, 'Given invalid device to update marker', device)
    marker.setLatLng([device.latitude, device.longitude])
    marker.bindPopup(`GRS: ${device.name}`)
    marker.setIcon(L.icon({
      iconUrl: groundRegisteredIcon, //TODO: icon based on GRS truancy
      iconSize: [25, 25],
      iconAnchor: [12.5, 12.5]
    }))
  }
  /**********************************************************************/

  processStatus(message) {
    const deviceId = message.data.localSource.deviceId
    let grs = this.grsMarkers[deviceId]

    if (message.data.local.position.latitude === 0 &&
      message.data.local.position.longitude === 0) return

    const device = {
      ...skylineApi.getDevice(deviceId),
      id: deviceId,
      latitude: message.data.local.position.latitude,
      longitude: message.data.local.position.longitude,
      remoteRadioStatus: message.data.remote.protocol.radioStatus,
    }

    if (!grs) {
      grs = this.addMarker(device)
    } else {
      this.updateMarker(device)
    }

  }

  handleMissionStep(message) {
    if (message.type == 'SKYLINK_ADV_STATUS') {
      this.processStatus(message)
    }
  }

  clearGrsMarkers() {
    for (const deviceId in this.grsMarkers) {
      this.grsMarkers[deviceId].removeFrom(this.grsLayer)
    }
    this.grsMarkers = {}
  }

  cleanup() {
    super.cleanup()
    if (this.addedLayer) {
      this.grsLayer.removeFrom(mymap)
      removeOverlay(this.overlay)
    }
  }
}